import * as React from "react";
const SvgActiveEllipse = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 8, height: 8, viewBox: "0 0 8 8", fill: "none", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 3.5, fill: "#52C41A", stroke: "white" }));
export default SvgActiveEllipse;
